<div class="plan" [ngClass]="mealPeriodClass" role="row">
    <div class="name" role="cell">{{plan.type}}</div>
    <div class="container" *ngFor="let year of plan.entitlements">
        <ng-container *ngFor="let entitlement of year">
            <span *ngIf="entitlement.quantity" role="cell">
                {{entitlement.quantity}}
                <span class="meal-type">
                    {{entitlement.mealPeriod}}
                </span>
            </span>
        </ng-container>
    </div>
</div>
